import { render, staticRenderFns } from "./recommendedCashBack.vue?vue&type=template&id=339e0e0d&scoped=true"
import script from "./recommendedCashBack.vue?vue&type=script&lang=js"
export * from "./recommendedCashBack.vue?vue&type=script&lang=js"
import style0 from "./recommendedCashBack.vue?vue&type=style&index=0&id=339e0e0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339e0e0d",
  null
  
)

export default component.exports